export const hashValueIsBlank = ()=>{
    const hash = window.location.hash
    if (hash!==null && hash!==''){
        return false;
    }
    return true
}
